import { Column, Content, Theme } from "@carbon/react";
import { Fragment } from "react";

import { IOnboardingViewProps } from "./Onboarding";
import { OnboardingHeader } from "./OnboardingHeader";

import { OnboardingStep1 } from "./OnboardingStep1";
import { OnboardingStep2 } from "./OnboardingStep2";
import { OnboardingStep3 } from "./OnboardingStep3";
import { OnboardingStep4 } from "./OnboardingStep4";
import { OnboardingStep5 } from "./OnboardingStep5";
import { OnboardingStep6 } from "./OnboardingStep6";
import { OnboardingStepDisplay } from "./OnboardingStepDisplay";

export const View = (props /*: IOnboardingViewProps*/) => {
  const {
    step,
    stepsPerPage,
    totalSteps,
    handleNext,
    handlePrevious,
    handleComplete,
    handleCancel,
  } = props;

  const onboardingStepPages = [
    <OnboardingStep1
      handleNext={handleNext}
      handlePrevious={handlePrevious}
      isActive={step === 1}
    />,
    <OnboardingStep2
      handleNext={handleNext}
      handlePrevious={handlePrevious}
      isActive={step === 2}
    />,
    <OnboardingStep3
      handleNext={handleNext}
      handlePrevious={handlePrevious}
      isActive={step === 3}
    />,
    <OnboardingStep4
      handleNext={handleNext}
      handlePrevious={handlePrevious}
      isActive={step === 4}
    />,
    <OnboardingStep5
      handleNext={handleNext}
      handlePrevious={handlePrevious}
      isActive={step === 5}
    />,
    <OnboardingStep6
      handleNext={handleNext}
      handlePrevious={handlePrevious}
      handleComplete={handleComplete}
      isActive={step === 6}
    />,
  ];

  return (
    <Content className="onboarding-content">
      <Column lg={16} md={8} sm={4}>
        <OnboardingHeader
          handleComplete={handleComplete}
          handleCancel={handleCancel}
          isCompleteEnabled={step === totalSteps}
        />

        <OnboardingStepDisplay
          step={step}
          stepsPerPage={stepsPerPage}
          totalSteps={totalSteps}
        />

        <div className="flex-container flex-break--small onboarding-container">
          {onboardingStepPages.map((page, index) => {
            const pageStepNumber = index + 1;
            const isActive = pageStepNumber === step;
            const is_disabled = pageStepNumber > step;
            // const isCompleted = pageStepNumber < step;
            const isFirstPageInView = pageStepNumber % stepsPerPage === 1;

            const isVisible =
              Math.floor(index / stepsPerPage) ===
              Math.max(Math.floor((step - 1) / stepsPerPage), 0);

            return is_disabled || !isVisible ? null : (
              <Fragment key={index}>
                {isFirstPageInView ? null : (
                  <div className="flex-divider--vertical" />
                )}

                {
                  <div
                    className={`flex-box flex-container section-container ${
                      !isActive ? "page-inactive" : ""
                    }`}
                  >
                    {page}
                  </div>
                }
              </Fragment>
            );
          })}

          {Array.from(
            { length: (stepsPerPage - (step % stepsPerPage)) % stepsPerPage },
            (v, k) => k
          ).map((v, k) => (
            <div key={k} className="flex-box inactive-steps--cover" />
          ))}
        </div>
      </Column>
    </Content>
  );
};
